import firebase from '../../../config/firebase';
import moment from 'moment';
import { func } from 'prop-types';

const database = firebase.database();

/**
 * Get Featured Events
 */
export function getEvents (callback) {
    // if (auth.currentUser) {
        database.ref('events').on('value', function (snapshot) {
                const events = snapshot.val();
                callback(true, events, null);
            })

    // } else {
    //     callback(false, null, {code: 401, message: 'Session expired.'});
    // }
}

/**
 * Create new event
 */
export function createNewEvent (data, callback) {
    let parentId = null;
    let counter = 1;
    switch (data?.repeat) {
        case 'once':
            while (counter > 0) {
                data["id"] = database.ref().child('events').push().key;
                data["parentId"] = data['id']
                database.ref('events').child(`${data['id']}`).set(data).then((error) => {
                    if (error) {
                        callback(false, null, error);
                    } else {
                        callback(true, data, null);
                    }
                });
                counter = counter - 1;
            }
            break;
        case 'daily':
            counter = 365;
            while (counter > 0) {
                data["id"] = database.ref().child('events').push().key;
                if (counter === 365) {
                    parentId = data['id'];
                }
                data['parentId'] = parentId;
                database.ref('events').child(`${data['id']}`).set(data).then((error) => {
                    if (error) {
                        callback(false, null, error);
                    } else {
                        callback(true, data, null);
                    }
                });
                counter = counter - 1;
                data['date'] = moment(data['date']).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarStart'] = moment(data['calendarStart']).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarEnd'] = moment(data['calendarEnd']).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss');
            }
            alert(`Created 365 events: ${data?.title}\nLast event on ${moment(data?.date).add(1, 'years').format('MMMM Do YYYY')}`);
            break;
        case 'week':
        case 'weekly':
            counter = 52;
            while (counter > 0) {
                data["id"] = database.ref().child('events').push().key;
                if (counter === 52) {
                    parentId = data['id'];
                }
                data['parentId'] = parentId;
                database.ref('events').child(`${data['id']}`).set(data).then((error) => {
                    if (error) {
                        callback(false, null, error);
                    } else {
                        callback(true, data, null);
                    }
                });
                counter = counter - 1;
                data['date'] = moment(data['date']).add(1, 'weeks').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarStart'] = moment(data['calendarStart']).add(1, 'weeks').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarEnd'] = moment(data['calendarEnd']).add(1, 'weeks').format('YYYY-MM-DDTHH:mm:ss');
            }
            alert(`Created 52 events: ${data?.title}\nLast event on ${moment(data?.date).add(1, 'years').format('MMMM Do YYYY')}`);
            break;
        case '2weeks':
        case 'biweekly':
            counter = 26;
            while (counter > 0) {
                data["id"] = database.ref().child('events').push().key;
                if (counter === 26) {
                    parentId = data['id'];
                }
                data['parentId'] = parentId;
                database.ref('events').child(`${data['id']}`).set(data).then((error) => {
                    if (error) {
                        callback(false, null, error);
                    } else {
                        callback(true, data, null);
                    }
                });
                counter = counter - 1;
                data['date'] = moment(data['date']).add(2, 'weeks').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarStart'] = moment(data['calendarStart']).add(2, 'weeks').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarEnd'] = moment(data['calendarEnd']).add(2, 'weeks').format('YYYY-MM-DDTHH:mm:ss');
            }
            alert(`Created 26 events: ${data?.title}\nLast event on ${moment(data?.date).add(1, 'years').format('MMMM Do YYYY')}`);
            break;
        case 'month':
        case 'monthly':
            counter = 12;
            while (counter > 0) {
                data["id"] = database.ref().child('events').push().key;
                if (counter === 12) {
                    parentId = data['id'];
                }
                data['parentId'] = parentId;
                database.ref('events').child(`${data['id']}`).set(data).then((error) => {
                    if (error) {
                        callback(false, null, error);
                    } else {
                        callback(true, data, null);
                    }
                });
                counter = counter - 1;
                data['date'] = moment(data['date']).add(1, 'months').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarStart'] = moment(data['calendarStart']).add(1, 'months').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarEnd'] = moment(data['calendarEnd']).add(1, 'months').format('YYYY-MM-DDTHH:mm:ss');
            }
            alert(`Created 12 events: ${data?.title}\nLast event on ${moment(data?.date).add(1, 'year').format('MMMM Do YYYY')}`);
            break;
        case 'year':
        case 'yearly':
            counter = 10;
            while (counter > 0) {
                data["id"] = database.ref().child('events').push().key;
                if (counter === 10) {
                    parentId = data['id'];
                }
                data['parentId'] = parentId;
                database.ref('events').child(`${data['id']}`).set(data).then((error) => {
                    if (error) {
                        callback(false, null, error);
                    } else {
                        callback(true, data, null);
                    }
                });
                counter = counter - 1;
                data['date'] = moment(data['date']).add(1, 'years').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarStart'] = moment(data['calendarStart']).add(1, 'years').format('YYYY-MM-DDTHH:mm:ss');
                data['calendarEnd'] = moment(data['calendarEnd']).add(1, 'years').format('YYYY-MM-DDTHH:mm:ss');
            }
            alert(`Created 10 events: ${data?.title}\nLast event on ${moment(data?.date).add(10, 'years').format('MMMM Do YYYY')}`);
            break;
        default:
            break;
    }
    
}

/**
 * Edit event
 */
export function editEvent (id, data, callback) {

    database.ref('events/' + id).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    });
}

/**
 * Change featured attribute of Event
 */
export function changeFeature(id, value, callback) {
    database.ref('events/' + id + '/isFeatured').set(value, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}

export function changeStarred(id, value, callback) {
    database.ref('events/' + id + '/isStarred').set(value, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}

/**
 * Delete event
 */
export function deleteEvent(id, callback) {
    database.ref('events').child(id).remove(function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}

export function deleteAllEventOccurrences(id, callback) {
    let error = null;
    database.ref('events').child(id).once('value').then(e => {
        database.ref('events').orderByChild('parentId').once('value').then(allEvents => {
            Object.values(allEvents.val()).map(event => {
                if (e.val()?.parentId === event?.parentId) {
                    database.ref('events').child(event.id).remove().catch(err => error = err);
                }
            })
        }).catch(err => error = err);
    })
    .then(() =>  callback(true, id, null))
    .catch(err => error = err);
}

export function saveSpecials(data, callback) {
    database.ref('specials').set(data, function (error) {
        if (error) {
            callback(false, error);
        } else {
            callback(true, null);
        }
    })
}

export function loadSpecials(callback) {
    database.ref('specials').once('value')
        .then((snapshot) => {
            const specials = snapshot.val();
            callback(true, specials, null);
        })
}
